import type { JSX } from "react";

import { Route, Routes } from "react-router-dom";
import ImageThreadsPage from "./ImageThreadsPage";
import ImageThreadView from "./ImageThreadView";

function ImageThreadsRoutes(): JSX.Element {
    return (
        <Routes>
            <Route index element={<ImageThreadsPage />} />
            <Route path=":id" element={<ImageThreadView />} />
        </Routes>
    );
}

export default ImageThreadsRoutes;
